import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ErrorMessage, Form, Formik } from "formik";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import CustomInput from "../../../CustomComponent/custom_input";
import CustomSelect from "../../../CustomComponent/custom_select";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import LoadingPage from "../../../Components/layouts/loading";
import { taskManagementInfo } from "../../../SchemaInfo/info";
import { CreateTaskSchema } from "../../../Schemas/Task Management/create_task";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import CustomRadioButton from "../../../CustomComponent/custom_radio";
import { BsPatchPlus } from "react-icons/bs";
import { FcCalendar } from "react-icons/fc";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { useSelector } from "react-redux";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

const CreateTask = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [leadOwner, setLeadOwner] = useState();
  let userData = useSelector((store) => store.login.user);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    performRequest("GET", "/leads/getAllLeadsOwners")
      .then((res) => setLeadOwner(res?.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  const handleSubmit = (values, actions) => {
    // const Values = {
    //   ...values,
    //   status: "pending",
    //   generatedBy: userData.Name
    // };
    // console.log(values);
    values = {
      ...values,
      taskType:
        values.taskType.toLowerCase() === "weekday task"
          ? "repeat task"
          : values.taskType.toLowerCase(),
    };
    let formData = new FormData();
    for (let key in values) {
      formData.append(key, values[key]);
    }
    const headers = { "Content-Type": "multipart/form-data" };
    setLoading(true);
    performRequest("POST", "/tasks/createTaskManagement/", formData, headers)
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "Task created successfully!");
          navigate(`/task-management`);
        } else {
          Toast("error", "Error while Creating");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error");
        // console.error("Error", err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  function getUpcomingDateFromDay(dayName) {
    const daysMap = {
      sunday: 0,
      monday: 1,
      tuesday: 2,
      wednesday: 3,
      thursday: 4,
      friday: 5,
      saturday: 6,
    };

    const targetDay = daysMap[dayName.toLowerCase()];
    if (targetDay === undefined) {
      throw new Error("Invalid day name");
    }

    const today = new Date();
    const todayDay = today.getDay();

    let diff = targetDay - todayDay;
    if (diff <= 0) diff += 7; // ensures UPCOMING (not today)

    const upcomingDate = new Date(today);
    upcomingDate.setDate(today.getDate() + diff);

    return upcomingDate.toISOString().split("T")[0];
  }

  const difficultyText = {
    Small: "15 minutes to 1 hour",
    Medium: "1 to 3 hours",
    Large: "Requires one full working day",
    ExtraLarge: "Requires multiple days",
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcCalendar className="fs-2  me-1" /> Create New Task
                </h2>
                <h4 className="text-muted">Allot & create new tasks.</h4>
              </div>
              <div className="col-md-4">
                {/* <div className="btn-list justify-content-end">
                  <a href={"/task-management"}>
                    <button className="btn btn-primary">
                      <BsPatchPlus className="me-2 fs-2" /> View Task List
                    </button>
                  </a>
                </div> */}
                <div className="btn-list justify-content-end">
                  {(userData?.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                    userData?.Role === process.env.REACT_APP_ROLE_ADMIN ||
                    userData?.Role ===
                      process.env.REACT_APP_ROLE_SALES_MANAGER ||
                    userData?.Role === process.env.REACT_APP_ROLE_IT ||
                    userData?.Role === process.env.REACT_APP_ROLE_PURCHASE ||
                    userData?.Role === process.env.REACT_APP_ROLE_ACCOUNTS ||
                    userData?.Role === process.env.REACT_APP_ROLE_AGRONOMIST ||
                    userData?.Role === process.env.REACT_APP_ROLE_OPS ||
                    userData?.Role === process.env.REACT_APP_ROLE_SALLE ||
                    userData?.Role === process.env.REACT_APP_ROLE_SALLE_ADMIN ||
                    userData?.Role === process.env.REACT_APP_ROLE_INSPECTION ||
                    userData?.Role === process.env.REACT_APP_ROLE_MARKETING ||
                    userData?.Role === process.env.REACT_APP_ROLE_SSM ||
                    userData?.Role ===
                      process.env.REACT_APP_ROLE_SALESCOORDINATOR ||
                    userData?.Role ===
                      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK) && (
                    <a href={"/task-management"}>
                      <button className="btn btn-primary">
                        <BsPatchPlus className="me-2 fs-2" /> View Task List
                      </button>
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-3">
                <p>Only Super Admins and Admins can creat tasks.</p>
                <p>
                  You can not allot tasks to clients or someone out of the
                  organization.
                </p>
              </div>
              <div className="card mt-2">
                <div className="card-header">
                  <h3 className="card-title">Task Difficulty Policy</h3>
                </div>

                <div className="card-body">
                  <h3>Small</h3>
                  <ul><strong>15</strong> minutes to <strong>1</strong> hours</ul>

                  <h3>Medium</h3>
                  <ul>
                    <strong>1</strong> to <strong>3</strong> hours
                  </ul>

                  <h3>Large</h3>
                  <ul>
                    Requires <strong>one</strong> full working day
                  </ul>

                  <h3>Extra Large</h3>
                  <ul>
                    Requires <strong>multiple</strong> days
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                <Formik
                  initialValues={taskManagementInfo}
                  validationSchema={CreateTaskSchema}
                  onSubmit={handleSubmit}
                >
                  {(props) => (
                    <Form>
                      <div className="card-body">
                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 required">
                            Task
                          </label>
                          <div className="w-100 col">
                            <CustomInput name="name" type="text" />
                            {props.touched.name && props.errors.name && (
                              <p className="text-danger">{props.errors.name}</p>
                            )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Task type
                          </label>
                          <div className="w-100 col">
                            <div>
                              <label className="form-check form-check-inline">
                                <CustomRadioButton
                                  name="taskType"
                                  value="one time"
                                />
                                <span className="form-check-label">
                                  One Time
                                </span>
                              </label>
                              <label className="form-check form-check-inline">
                                <CustomRadioButton
                                  name="taskType"
                                  value="repeat task"
                                />
                                <span className="form-check-label">
                                  Repeat Task
                                </span>
                              </label>
                              <label className="form-check form-check-inline">
                                <CustomRadioButton
                                  name="taskType"
                                  value="weekday task"
                                />
                                <span className="form-check-label">
                                  Weekday Task
                                </span>
                              </label>
                            </div>
                            <ErrorMessage
                              name="taskType"
                              component="p"
                              className="text-danger"
                            />
                          </div>
                        </div>
                        {props.values.taskType === "one time" && (
                          <div className="mb-3 row">
                            <label className="w-25 form-label col-3">
                              Deadline
                            </label>
                            <div className="w-100 col">
                              <CustomInput name="deadline" type="date" />
                              <ErrorMessage
                                name="deadline"
                                component="p"
                                className="text-danger"
                              />
                            </div>
                          </div>
                        )}
                        {props.values.taskType === "repeat task" && (
                          <>
                            <div className="mb-3 row">
                              <label className="w-25 form-label required col-3">
                                Start date
                              </label>
                              <div className="w-100 col">
                                <CustomInput name="startDate" type="date" />
                                <ErrorMessage
                                  name="startDate"
                                  component="p"
                                  className="text-danger"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label className="w-25 form-label col-3">
                                End date
                              </label>
                              <div className="w-100 col">
                                <CustomInput name="endDate" type="date" />
                                <ErrorMessage
                                  name="endDate"
                                  component="p"
                                  className="text-danger"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label className="w-25 form-label col-3 required">
                                Frequency
                              </label>
                              <div className="w-100 col">
                                <div className="d-flex">
                                  <CustomSelect
                                    className="me-2 form-select"
                                    name="frequency"
                                    type="text"
                                    style={{ width: "50%" }}
                                  >
                                    <option value="">Select</option>
                                    {[...Array(31).keys()].map((day) => (
                                      <option key={day + 1} value={day + 1}>
                                        {day + 1}
                                      </option>
                                    ))}
                                  </CustomSelect>
                                  <CustomSelect
                                    name="frequencyType"
                                    type="text"
                                    style={{ width: "50%" }}
                                  >
                                    <option value="">Select Type</option>
                                    <option value="days">Days</option>
                                    <option value="months">Months</option>
                                    <option value="year">Year</option>
                                  </CustomSelect>
                                </div>
                                {props.touched.frequencyType &&
                                  props.errors.frequencyType && (
                                    <p className="text-danger">
                                      {props.errors.frequencyType}
                                    </p>
                                  )}
                                {props.touched.frequency &&
                                  props.errors.frequency && (
                                    <p className="text-danger">
                                      {props.errors.frequency}
                                    </p>
                                  )}
                              </div>
                            </div>
                          </>
                        )}
                        {props.values.taskType === "weekday task" && (
                          <>
                            <div className="mb-3 row">
                              <label className="w-25 form-label col-3 required">
                                Day of week
                              </label>
                              <div className="w-100 col">
                                <CustomSelect
                                  className="me-2 form-select"
                                  name="weekDay"
                                  type="text"
                                  onChange={(e) => {
                                    props.setFieldValue("frequency", 7);
                                    props.setFieldValue(
                                      "frequencyType",
                                      "days"
                                    );
                                    props.setFieldValue(
                                      "weekDay",
                                      e.target.value
                                    );
                                    props.setFieldValue(
                                      "startDate",
                                      getUpcomingDateFromDay(e.target.value)
                                    );
                                  }}
                                >
                                  <option value="">Select</option>
                                  {days.map((day, index) => (
                                    <option key={day} value={day}>
                                      {day}
                                    </option>
                                  ))}
                                </CustomSelect>
                                {props.touched.frequency &&
                                  props.errors.frequency && (
                                    <p className="text-danger">
                                      {props.errors.frequency}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label className="w-25 form-label col-3">
                                End date
                              </label>
                              <div className="w-100 col">
                                <CustomInput name="endDate" type="date" />
                                <ErrorMessage
                                  name="endDate"
                                  component="p"
                                  className="text-danger"
                                />
                              </div>
                            </div>
                          </>
                        )}

                        <div className="mb-3 row" ref={dropdownRef}>
                          <label className="w-25 form-label col-3 required">
                            Assign to
                          </label>
                          <div className="w-100 col">
                            {/* Dropdown Toggle Button */}
                            <div
                              className="form-control d-flex justify-content-between align-items-center"
                              onClick={() => setDropdownOpen(!dropdownOpen)}
                              style={{ cursor: "pointer" }}
                            >
                              {props.values.assignTo.length > 0
                                ? `Selected (${props.values.assignTo.length})`
                                : "Select Users"}
                              {dropdownOpen ? (
                                <FaChevronUp />
                              ) : (
                                <FaChevronDown />
                              )}
                            </div>

                            {/* Dropdown Menu */}
                            {dropdownOpen && (
                              <div
                                className="dropdown-menu show"
                                style={{
                                  position: "absolute",
                                  width: "50%",
                                  maxHeight: "200px",
                                  overflowY: "auto",
                                  background: "white",
                                  border: "1px solid #ccc",
                                  zIndex: 1000,
                                }}
                              >
                                {leadOwner &&
                                  leadOwner.map((pro) => (
                                    <label
                                      key={pro.id}
                                      className="dropdown-item d-flex align-items-center"
                                    >
                                      <input
                                        style={{
                                          height: "18px",
                                          width: "18px",
                                        }}
                                        type="checkbox"
                                        value={pro.userName}
                                        checked={props.values.assignTo.includes(
                                          pro.userName
                                        )}
                                        onChange={(e) => {
                                          const selected =
                                            props.values.assignTo.includes(
                                              pro.userName
                                            )
                                              ? props.values.assignTo.filter(
                                                  (userName) =>
                                                    userName !== pro.userName
                                                )
                                              : [
                                                  ...props.values.assignTo,
                                                  pro.userName,
                                                ];

                                          props.setFieldValue(
                                            "assignTo",
                                            selected
                                          );
                                        }}
                                        className="me-2"
                                      />
                                      {pro.userName}
                                    </label>
                                  ))}
                              </div>
                            )}

                            {props.touched.assignTo &&
                              props.errors.assignTo && (
                                <p className="text-danger">
                                  {props.errors.assignTo}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3">
                            Description
                          </label>
                          <div className="w-100 col">
                            <CustomTextArea name="description" type="text" />
                            {props.touched.description &&
                              props.errors.description && (
                                <p className="text-danger">
                                  {props.errors.description}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label  col-3">
                            Reference image
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="uploadImage"
                              type="file"
                              onChange={(e) =>
                                props.setFieldValue(
                                  "uploadImage",
                                  e.target.files[0]
                                )
                              }
                            />
                            {props.touched.uploadImage &&
                              props.errors.uploadImage && (
                                <p className="text-danger">
                                  {props.errors.uploadImage}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label  col-3">
                            Priority
                          </label>
                          <div className="w-100 col">
                            <CustomSelect name="priority" type="text">
                              <option value="">Select Priority</option>
                              <option value="P1">P1</option>
                              <option value="P2">P2</option>
                              <option value="P3">P3</option>
                            </CustomSelect>
                            {props.touched.priority &&
                              props.errors.priority && (
                                <p className="text-danger">
                                  {props.errors.priority}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label  col-3">
                            Task Difficulty
                          </label>
                          <div className="w-100 col">
                            <CustomSelect name="taskDifficulty" type="text">
                              <option value="">Select Difficulty</option>
                              <option value="Small">Small</option>
                              <option value="Medium">Medium</option>
                              <option value="Large">Large</option>
                              <option value="ExtraLarge">Extra Large</option>
                            </CustomSelect>
                            {props.values.taskDifficulty && (
  <small className="text-danger fs-4 fw-semibold">
    {difficultyText[props.values.taskDifficulty]}
  </small>
)}
                          </div>
                        </div>
                      </div>
                      <div className="card-footer">
                        <div className="btn-list justify-content-end">
                          <FormSubmitButton buttonText="Create Task" />
                          <SimpleButton buttonText="Cancel" type="secondary" />
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default CreateTask;
